import { NG_VALUE_ACCESSOR } from '@angular/forms';
import {
  Component,
  ElementRef,
  EventEmitter,
  HostBinding,
  HostListener,
  Input,
  Output,
} from '@angular/core';

@Component({
    selector: 'lui-text-box',
    template: `{{ value }}`,
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            multi: true,
            useExisting: TextBoxComponent,
        },
    ],
    standalone: false
})
export class TextBoxComponent {
  @HostBinding('attr.role.text-box') role = true;

  @HostBinding('attr.contenteditable') contenteditable = true;

  @HostBinding('class') hostClass = 'lui-text-box';

  @Input() @HostBinding('attr.placeholder') placeholder!: string;

  value!: string;

  touched = false;

  disabled = false;

  focused = false;

  @Output() blurred = new EventEmitter<void>();

  _onChange: (value: unknown | unknown[]) => void = () => undefined;

  _onTouched: () => void = () => undefined;

  @HostListener('input')
  onInput() {
    this._onChange(this._elementRef.nativeElement.innerText);
  }

  @HostListener('focus')
  onFocus() {
    this._focusChanged(true);
  }

  @HostListener('blur')
  onBlur() {
    this._focusChanged(false);
    this.blurred.emit();
  }

  constructor(private _elementRef: ElementRef) {}

  writeValue(value: string): void {
    this.value = value;
  }

  registerOnChange(fn: (value: unknown) => void) {
    this._onChange = fn;
  }

  registerOnTouched(fn: () => void) {
    this._onTouched = fn;
  }

  focus(options?: FocusOptions): void {
    this._elementRef.nativeElement.focus(options);
  }

  _focusChanged(isFocused: boolean) {
    if (isFocused !== this.focused) {
      this.focused = isFocused;
      // this.stateChanges.next();
    }
  }
}
